const env = process.env.NODE_ENV
// 开发环境运行命令：npm run serve
// 生产环境打包命令：npm run build
// 测试环境打包命令：npm run test
const IP = {
  development: { // 本地开发环境
    // baseIP: 'https://hy.spbcn.org/erp/', // pro
    baseIP: 'https://hy.spbcn.org/erp_test/', // test
    // baseIP: 'http://192.168.0.107:9888/erp_test/', // local
    baseWebIP: 'https://hy.spbcn.org/web_test/',
    // baseWebIP: 'http://192.168.0.55:9888/erp_test/',
    wechatWebIP: 'https://hy.spbcn.org/applets_test/'
  },
  production: { // 生产环境
    // baseIP: 'https://hy.spbcn.org/erp_test/'
    baseIP: 'https://hy.spbcn.org/erp/',
    baseWebIP: 'https://hy.spbcn.org/web/',
    wechatWebIP: 'https://hy.spbcn.org/applets/'
  },
  test: { // 测试环境
    baseIP: 'https://hy.spbcn.org/erp_test/',
    // baseIP: 'http://127.0.0.1:9888/erp_test/',
    baseWebIP: 'https://hy.spbcn.org/web_test/',
    wechatWebIP: 'https://hy.spbcn.org/applets_test/'
  }
}
export default IP[env]
